export const getIntensityColor = (mode: 'light' | 'dark') => {
    return mode === 'dark' ? 0.3 : 0.5;
};
